import React, { useEffect,  useState } from "react";
import styled from "styled-components";
import { bockUserApi, userListingApi } from "services/collection";
import TableAction from "app/component/tables/TableAction";
import SearchField from "app/component/SearchField";
import BlockUser from "app/modals/BlockUser";
import UserDetailModal from "app/modals/UserDetailModal";
import UserTableCard from "./UserTableCard";
import ImageTage from "app/component/ImageTage";
import { userModify } from "utils/modifyRespones";
import Selecter from "app/component/Selecter";
import TableComponent from "app/component/tables/TableComponent";
import {
  HeaderFilterWrapper,
  HeaderWrapper,
  Heading,
  TotalCounter,
} from "utils/commonStyle";
import {
  calculateHeight,
  errorMessage,
  snoIndex,
  successMessage,
} from "utils/commonFunction";

import {
  bydefaultCurrentPage,
  bydefaultLimit,
  sortOptions,
  statusOption,
} from "utils/constant";
import Cardwrapper from "app/component/tables/Cardwrapper";

const UserListing = () => {;
  const [open, setOpen] = useState(false);
  const [blockopen, setBlock] = useState(false);
  const [search, setSearch] = useState(null);
  const [status, setStatus] = useState(false);
  const [sortFilter, setSortFilter] = useState(false);
  const [id, setId] = useState("");
  const [idActived, setIdActived] = useState(null);
  const [loading, setLoading] = useState(false);
  const [listing, SetListing] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: bydefaultCurrentPage,
    pageSize: bydefaultLimit,
    total: 0,
  });

  const getListing = async () => {
    setLoading(true);
    const params = new URLSearchParams();
    params.append("limit", pagination?.pageSize);
    params.append("page", pagination?.current);
    search && params.append("search", search);
    sortFilter && params.append("sortFilter", sortFilter);
    status && params.append("shortActiveUsers", status);
    const res = await userListingApi(params.toString());
    if (res?.status === 200) {
      const result = await userModify(res?.data?.users);
      SetListing(result);
      setPagination({ ...pagination, total: res?.data?.totalUsers });
    } else {
      errorMessage(res);
    }
    setLoading(false);
  };
  function onChange(pagination) {
    setPagination(pagination);
  }

  const handleAction = (value) => {
    console.log(value,'sfefewfe')
    setId(value?._id);
    setIdActived(value?.idActive);
    if (value?.actiontype === "info") {
      setOpen(true);
    } else if (value?.actiontype === "block") {
      setBlock(true);
    }
  };

  const handleCancel = () => {
    setOpen(false);
    setBlock(false);
  };

  const handleSearch = (value) => {
    setSearch(value);
    setPagination({ ...pagination, current: 1 });
  };

  const handleSorting = (value) => {
    setSortFilter(value);
    setPagination({ ...pagination, current: 1 });
  };

  const handleSelectStatus = (value) => {
    setStatus(value);
    setPagination({ ...pagination, current: 1 });
  };

  const blocked = async () => {
    setConfirmLoading(true);
    const params = {
      recieverId: id,
      status: "2",
    };
    const res = await bockUserApi(params);
    if (res?.status === 200) {
      successMessage(res);
      getListing();
    } else {
      errorMessage(res);
    }
    setConfirmLoading(false);
    handleCancel();
    return res?.message;
  };

  useEffect(() => {
    getListing();
  }, [pagination?.current, search, sortFilter, status]);

  const columns = [
    {
      title: "S.No",
      dataIndex: "index",
      key: "index",
      render: (index) => snoIndex({ index, pagination }),
      width: "60px",
    },
    {
      title: "Name",
      dataIndex: "profileName",
      key: "profileName",
      render: (profileName, record) => (
        <div
          className="Image-section"
          onClick={() => handleAction({ ...record, actiontype: "info" })}
        >
          <ImageTage className="table-image" src={profileName?.thumbnail} />
          <p>{profileName?.fullName}</p>
        </div>
      ),
      width: "180px",
    },

    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: "120px",
    },
    {
      title: "Gender",
      dataIndex: "identity",
      key: "identity",
      width: "80px",
    },

    {
      title: "Age",
      dataIndex: "userAge",
      key: "userAge",
      width: "50px",
    },
    {
      title: "Login Type",
      dataIndex: "loginTypecheck",
      key: "loginTypecheck",
      width: "120px",
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      width: "220px",
    },
    {
      title: "Status",
      dataIndex: "checkStatus",
      key: "checkStatus",
      width: "100px",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div>
          <TableAction
            tableAction={{info: true, block: true }}
            record={record}
            handlClick={handleAction}
          />
        </div>
      ),
      width: "80px",
    },
  ];

  return (
    <>
      <UserDetailModal
        openModal={open}
        handleCancel={handleCancel}
        userId={id}
        blocked={blocked}
      />
      <BlockUser
        msg={idActived}
        openModal={blockopen}
        handleCancel={handleCancel}
        loading={confirmLoading}
        handleOk={blocked}
        title={"User Status"}
      />
      <StyledDashboard>
        <HeaderWrapper>
          <Heading>Users</Heading>
          <HeaderFilterWrapper>
            <SearchField handleSearch={handleSearch} />
            <Selecter
              allowClear={true}
              placeholder={"Sort By"}
              options={sortOptions}
              handleSelect={handleSorting}
            />
            <Selecter
              allowClear={true}
              placeholder={"Status"}
              options={statusOption}
              handleSelect={handleSelectStatus}
            />
            <TotalCounter>Total Users: {pagination?.total || "0"}</TotalCounter>
          </HeaderFilterWrapper>
        </HeaderWrapper>
        <Cardwrapper
          table={
            <TableComponent
              loading={loading}
              listing={listing}
              columns={columns}
              pagination={pagination}
              onChange={onChange}
              padding={"2px 5px"}
              scrollHeight={calculateHeight(200)}
            />
          }
          tableCard={listing?.map((el) => (
            <UserTableCard key={el.id} handleAction={handleAction} data={el} />
          ))}
          loading={loading}
          pagination={pagination}
          setPagination={setPagination}
        />
      </StyledDashboard>
    </>
  );
};

export default UserListing;

const StyledDashboard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .user-select {
    width: 200px;
    max-width: 100%;
  }

  .dashboard-header {
    display: flex;
    width: 100%;
    gap: 20px;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .card {
    background-color: #fff;
    padding: 24px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 300px;
    text-align: center;
    flex: 1;
  }

  .card-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 16px;
  }

  .card-value {
    font-size: 28px;
    font-weight: bold;
    color: #007bff;
  }

  .table-image {
    width: 50px;
    height: 50px;
    border-radius: 100%;
  }

  .Icons {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
  }

  .Image-section {
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    height: fit-content;
    gap: 14px;
    cursor: pointer;
  }
`;
